import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'ListItemRadio',
  props: {
    modelValue: {
      required: true,
    },
    name: {
      required: true,
      type: String,
    },
    inputId: {
      required: true,
      type: String,
    },
    label: {
      required: false,
      type: String,
    },
    sublabel: {
      required: false,
      type: String,
    },
    value: {
      required: true,
    },
    last: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['update:modelValue'],
})
export default class ListItemRadio extends Vue {
  modelValue!: any;
  name!: string;
  inputId!: string;
  value!: string;
  last!: boolean;
  label!: string;
  sublabel!: string;
  disabled!: boolean;

  get localValue() {
    return this.modelValue;
  }

  set localValue(v: any) {
    this.$emit('update:modelValue', v);
  }

  setRadioValue() {
    if (!this.disabled) this.localValue = this.value;
  }
}
